import currency from 'currency.js';
import { Currency } from '../backend/types/generic';

export const USD = (value: any) => currency(value, { symbol: '$', precision: 2 });
export const EUR = (value: any) => currency(value, { symbol: '€', precision: 2 });
export const GBP = (value: any) => currency(value, { symbol: '£', precision: 2 });
export const SGD = (value: any) => currency(value, { symbol: 'S$', precision: 2 });

export const formatCurrency = (value: any, currency: Currency) => {
  switch (currency) {
    case 'EUR':
      return EUR(value);
    case 'GBP':
      return GBP(value);
    case 'USD':
      return USD(value);
    case 'SGD':
      return SGD(value);
    default:
      throw new Error('Invalid currency');
  }
};
